import styled from 'styled-components'

import { Row } from 'components/Grid'
import media from 'utils/media'
import { Link } from 'components/Common'

export const StyledRow = styled(Row)`
  margin-top: ${({ marginTopMb }) => marginTopMb}px;

  ${media.greaterThan('sm')`
    margin-top: ${({ marginTop }) => marginTop}px;
  `}
`

export const StyledLink = styled(Link)`
  color: #fff !important;
  margin-top: 45px;
`
export const EventStaticElemen = styled.div`
  background-color: ${({ theme }) => theme.colors.blueDark};
  padding: 57px 59px 36px 41px;
  color: #ffffff;
  ${media.greaterThan('md')`  
    padding: 106px 116px 77px 91px;
`}
`
